import type { ReactNode } from 'react';

/**
 * État vide.
 *
 * Un composant asynchrone sans état vide est un composant incomplet
 * (docs/DESIGN.md §3.2). Un tableau vide n'apprend rien ; un état vide dit
 * quoi faire ensuite.
 */
export interface EmptyStateProps {
  title: string;
  description: string;
  action?: ReactNode;
  tone?: 'neutral' | 'positive';
}

export function EmptyState({ title, description, action, tone = 'neutral' }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 rounded-lg border border-dashed border-border px-6 py-12 text-center">
      <p className="text-base font-semibold text-text">
        {tone === 'positive' ? '✓ ' : ''}
        {title}
      </p>
      <p className="max-w-md text-sm text-text-muted">{description}</p>
      {action ? <div className="pt-2">{action}</div> : null}
    </div>
  );
}
